import React, { createContext, useState, useContext, useEffect } from "react";
import axios from "axios";
const UserContext = createContext();

const apiUrl = process.env.REACT_APP_URL;

export const UserProvider = ({ children }) => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [username, setUsername] = useState(null);

  const [userData, setUserData] = useState({
    img_link: "",
    username: "",
    role: "",
    is_online: true,
    images: [],
  });

  const [palsData, setPalsData] = useState([]);
  const [profileData, setProfileData] = useState({
    img_link: "",
    username: "",
    first_name: "",
    last_name: "",
    country: "",
    city: "",
    birthdate: "",
    learned_language: "",
    native_language: "",
    description: "",
    education: "",
    hobbies: "",
    video_link: "",
    role: "",
  });
  const [hasUnreadMessages, setHasUnreadMessages] = useState(false);
  useEffect(() => {
    const setLoggedInStatus = async () => {
      try {
        const sessionRes = await axios.get(`${apiUrl}/auth/user`, {
          withCredentials: true,
        });

        if (sessionRes && sessionRes.success) {
          setIsLoggedIn(true);
          setUsername(sessionRes.data.username);
        } else {
          setIsLoggedIn(false);
          setUsername(null);
        }
      } catch (e) {}
    };

    setLoggedInStatus();
  }, []);

  // Fetch pals data
  useEffect(() => {
    const fetchPalsData = async () => {
      try {
        if (isLoggedIn) {
          const palsRes = await axios.get(
            `${apiUrl}/relationships/pals/${username}`,
            { withCredentials: true }
          );

          if (palsRes.status === 200) {
            setPalsData(palsRes.data);
          }
        }
      } catch (e) {
        console.error("Failed to fetch pals data", e);
      }
    };

    fetchPalsData();
  }, [isLoggedIn, username]);

  useEffect(() => {
    const fetchProfileData = async () => {
      try {
        if (isLoggedIn) {
          const userRes = await axios.get(`${apiUrl}/users/${username}`, {
            withCredentials: true,
          });

          if (userRes.status === 200) {
            const profile = {
              img_link: userRes.data.img_link,
              is_online: userRes.data.is_online,
              role: userRes.data.role,
              username: userRes.data.username,
              first_name: userRes.data.first_name,
              last_name: userRes.data.last_name,
              country: userRes.data.country,
              city: userRes.data.city,
              birthdate: userRes.data.birthdate,
              learned_language: userRes.data.learned_language,
              native_language: userRes.data.native_language,
              description: userRes.data.description,
              education: userRes.data.education,
              hobbies: userRes.data.hobbies,
              video_link: userRes.data.video_link,
              images: [],
            };

            setProfileData(profile);
          }
        }
      } catch (e) {
        console.error("Failed to fetch profile data", e);
      }
    };

    fetchProfileData();
  }, [isLoggedIn, username]);

  return (
    <UserContext.Provider
      value={{
        userData,
        setUserData,
        profileData,
        setProfileData,
        palsData,
        hasUnreadMessages,
        setHasUnreadMessages,
      }}
    >
      {children}
    </UserContext.Provider>
  );
};

export const useUser = () => useContext(UserContext);
